.scan-input-container {
    width: 300px;
}
